import React from 'react';
import ReactDOM from 'react-dom';

import 'airbnb-browser-shims';

import App from './App';
import * as serviceWorker from './serviceWorker';

import routes from './config/routes';

ReactDOM.render(
  <App routes={routes} />,
  /* eslint-disable comma-dangle */
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
